import React, {useEffect, useState} from "react";
import styles from "./NewsletterBenefits.module.scss";
import genericStyles from "../../../lib/GenericStyles.module.scss";
import {Trans, useTranslation} from "react-i18next";
import ReactDOM from "react-dom";
import {excludedManufacturers} from "../../../lib/ModalWindow/ApplicableVouchersModal";
import {RegistrationVoucher} from "../../../../helpers/registrationVoucher";

const NewsletterBenefits: React.FC = () => {
  const {t} = useTranslation();

  const [benefitsPortalDiv, setBenefitsPortalDiv] = useState<HTMLDivElement | null>();

  useEffect(() => {
    const footerNoteDiv = document.getElementById("footerNote") as HTMLDivElement;
    if (footerNoteDiv) {
      setBenefitsPortalDiv(footerNoteDiv);
    } else {
      const section = document.createElement("section");
      const div = document.createElement("div");
      div.id = "footerNote";
      section.append(div);
      document.querySelector("footer")?.insertAdjacentElement("beforebegin", section);
      setBenefitsPortalDiv(div);
    }

    return () => {
      setBenefitsPortalDiv(null);
    };
  }, []);

  const FooterNote = () => {
    return (
      <div className={`${styles.footerNote} ${genericStyles.footnote}`}>
        <sup className={genericStyles.footnoteIcon}>1</sup>
        <span>
          {
            /* ACHTUNG: wenn gerade eine Aktion läuft, bei der Prozentgutscheine nicht auf rabattierte Artikel
             * anwendbar sind, muss hier bei Prozentgutscheinen anstelle von newsletter.voucherFooterNote
             * der folgende Textbaustein ausgegeben werden: newsletter.voucherFooterNoteNoReducedProducts */
            RegistrationVoucher.rule?.intlUnit === "percent"
              ? t("newsletter.voucherFooterNote", {
                count: RegistrationVoucher.minOrderValue,
                manufacturers: excludedManufacturers,
                minOrderValue: RegistrationVoucher.minOrderValueFormatted,
              })
              : t("newsletter.voucherFooterNote", {
                count: RegistrationVoucher.minOrderValue,
                manufacturers: excludedManufacturers,
                minOrderValue: RegistrationVoucher.minOrderValueFormatted,
              })
          }{" "}
          <Trans
            i18nKey="newsletter.voucherConditionsApply"
            ns="translations"
            components={{
              a: <a href={t("url.voucherActionsLink")} target="_blank" rel="noreferrer" />,
            }}
          />
        </span>
      </div>
    );
  };

  const TwelvePercent = () => {
    if (!RegistrationVoucher.enabled) {
      return null;
    }

    return (
      <div className={styles.block}>
        <span className={`${styles.icon} icon-gift`} />
        <div>
          <h3>{t("newsletter.receiveWelcomeGift")}</h3>
          <p>
            <Trans
              i18nKey="newsletter.registrationWelcomeDiscount--amountFormatted"
              ns="translations"
              values={{
                amountFormatted: RegistrationVoucher.amountFormatted,
              }}
              components={{
                1: <sup className={genericStyles.footnoteReference} />,
              }}
            />
          </p>
          {benefitsPortalDiv && ReactDOM.createPortal(<FooterNote />, benefitsPortalDiv)}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <h3>{t("customer.yourAdvantages")}</h3>
      <div className={styles.benefitsWrapper}>
        <div className={styles.block}>
          <span className={`${styles.icon} icon-percent`} />
          <div>
            <h3>{t("newsletter.neverMissAnyDiscounts")}</h3>
            <p>{t("newsletter.regularExclusiveOffers")}</p>
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} icon-info`} />
          <div>
            <h3>{t("newsletter.newsTipsHomestories")}</h3>
            <p>{t("newsletter.receiveTipsAndDesignUpdates")}</p>
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} icon-coins`} />
          <div>
            <h3>{t("newsletter.trendsAndMore")}</h3>
            <p>{t("newsletter.winPrizesAndStayInformed")}</p>
          </div>
        </div>
        <TwelvePercent />
        <div className={styles.block}>
          <span className={`${styles.icon} icon-close`} />
          <div>
            <h3>{t("newsletter.freeAndCancelable")}</h3>
            <p>{t("newsletter.unsubscribeNewsletterAnyTime")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterBenefits;
